export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  code: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  codeProject: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  createDate: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  companyID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  branchID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  developmentID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  zipcode: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  address: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  number: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  complement: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  district: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  stateID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  cityID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  city: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/constructions/constructions-form.js